  import { add } from "lodash";
  import { helperServices } from "../../shared/helper";
  import history from "../../shared/utils/history";
  import { apiFetch } from "../../shared/helper/apiFetch";

  const basePath = "/api";

  // -------------------- Logout --------------------
  function logout() {
    localStorage.removeItem("user");
    history.push("/");
    window.location.reload();
  }

  // -------------------- Handle Response --------------------
  function handleResponse(response) {
    return response.text().then((text) => {
      const data = text && JSON.parse(text);
      const token = response.headers.get("Authorization");

      if (token != null && token !== undefined) {
        localStorage.setItem("token", JSON.stringify(token));
      }

      if (!response.ok) {
        if (response.status === 401) {
          logout(); // auto logout if 401 response returned from API
        }
        const error = (data && data.message) || response.statusText;
        return Promise.reject(error);
      }

      return data;
    });
  }

  // -------------------- Helper: Build Headers --------------------
  function buildHeaders() {
    const accessToken = helperServices.getAuthorization() || "";
    return {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: accessToken,
    };
  }

  // -------------------- Get All Patient Info --------------------
  function getAllPatientInfo(searchText) {
    const requestOptions = {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify(searchText),
    };
    const url = `${basePath}/master/patients`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Get Customer Group Info --------------------
  export function getCustomerGroupInfo() {
    const requestOptions = {
      method: "GET",
      headers: buildHeaders(),
    };
    const url = `${basePath}/v1/customerGroup`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Add Dependent --------------------
  // added on 17-04-2025 for add dependent flow
  function addDependent(data, patientid, visitId) {
    const requestOptions = {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify(data),
    };
    const url = `${basePath}/v1/addDependant?patientId=${patientid}&visitId=${visitId}`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Dependent Check --------------------
  function dependentCheck(patientid, visitId) {
    const requestOptions = {
      method: "GET",
      headers: buildHeaders(),
    };
    const url = `${basePath}/v1/dependants?patientId=${patientid}&visitId=${visitId}`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Keep Dependents --------------------
  function KeepDependents(data) {
    const requestOptions = {
      method: "POST",
      headers: buildHeaders(),
    };
    const url = `${basePath}/v1/dealocateWithDependants?patientId=${data.ptid}&visitId=${data.vid}&dischargeDate=${data.distdate}&checkType=${data.checkType}`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Add Patient --------------------
  // -------------------- Add Patient --------------------
  function addPatient(data, flag, admissionDateTime) {
    const requestOptions = {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify(data),
    };
    let url = `${basePath}/v1/ipd/patient`;
    const params = [];
    if (flag !== undefined && flag !== null && flag !== '') {
      params.push(`flag=${flag}`);
    }
    if (admissionDateTime !== undefined && admissionDateTime !== null && admissionDateTime !== '') {
      params.push(`admissionDate=${admissionDateTime}`);
    }
    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }
    return apiFetch(url, requestOptions);
  }
 
  // -------------------- Demo Controller --------------------
  function demoCon() {
    const requestOptions = {
      method: "GET",
      headers: buildHeaders(),
    };
    const url = `${basePath}/v1/Democontroller`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Update Patient --------------------
  function updatePatient(data, convert, admissionDateTime) {
    let image;
    if (data && data.upload && data.upload.file) {
      image = data.upload.file;
    }
    const requestOptions = {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify(data),
    };
    const url = `${basePath}/v1/ipd/patient?file =${image}&convert=${convert}&admissionDate=${admissionDateTime}`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Update Patient Aadhaar --------------------
  function updatePatientAdhaar(data) {
    const requestOptions = {
      method: "PUT",
      headers: buildHeaders(),
      body: JSON.stringify(data),
    };
    const url = `${basePath}/v2/patient/update`;
    return fetch(url, requestOptions)
      .then(handleResponse)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.error("Error updating patient:", error);
        throw error;
      });
  }

  // -------------------- Add Visit --------------------
  function addVisit(data) {
    const requestOptions = {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify(data),
    };
    const url = `${basePath}/master/visit`;
    return fetch(url, requestOptions).then(handleResponse);
  }

  // -------------------- Add Procedure --------------------
  function addProcedure(data) {
    const requestOptions = {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify(data),
    };
    const url = `${basePath}/master/procedure`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Get Visit Info --------------------
  function getVisitInfo() {
    const requestOptions = {
      method: "GET",
      headers: buildHeaders(),
      body: JSON.stringify(),
    };
    const url = `${basePath}/master/visit`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Get Insurance List --------------------
  function getInsuranceList(data) {
    const requestOptions = {
      method: "GET",
      headers: buildHeaders(),
    };
    const url = `${basePath}/v1/insurance?patientId=${data.patientId}&visitId=${data.visitId}`;
    return apiFetch(url, requestOptions);
  }
function getDoctors() {
  const requestOptions = {
    method: "GET",
    headers: buildHeaders(),
  };

  const url = `${basePath}/v1/doctors`;
  return apiFetch(url, requestOptions);
}
function uploadPatientImage(file) {
  const formData = new FormData();
  formData.append("file", file);

  const accessToken = helperServices.getAuthorization();

  return fetch(`${basePath}/v1/upload`, {
    method: "POST",
    headers: {
      Authorization: accessToken,
    },
    body: formData,
  }).then(handleResponse);
}
  // -------------------- Add Insurance Procedure --------------------
  function addInsuranceProcedure(data) {
    const requestOptions = {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify(data),
    };
    const url = `${basePath}/v1/insurance`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Update Insurance Procedure --------------------
  function updateInsuranceProcedure(data) {
    const requestOptions = {
      method: "PUT",
      headers: buildHeaders(),
      body: JSON.stringify(data),
    };
    const url = `${basePath}/v1/insurance`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- List Insurance Settlements --------------------
  function ListInsuranceSettlements(data) {
    const requestOptions = {
      method: "GET",
      headers: buildHeaders(),
    };
    const url = `${basePath}/v1/insurance/tobesettled`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Edit Insurance Settlements --------------------
  function EditInsuranceSettlements(data) {
    const requestOptions = {
      method: "GET",
      headers: buildHeaders(),
    };
    const url = `${basePath}/v1/insurance/settled?keyword=${data.keyword}`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Upload Attachments --------------------
  function uploadAttachments(fileData) {
    var accessToken;
    if (helperServices.getAuthorization()) {
      accessToken = helperServices.getAuthorization();
    }
    const formData = new FormData();
    formData.append("file", fileData, fileData.name);
    formData.append("sample", JSON.stringify({ name: "dummy" }));
    console.log("FormData-", formData);
    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: accessToken,
        "Content-Type": "x-www-form-urlencoded;charset=UTF-8",
      },
      body: formData,
    };
    const url = `${basePath}/v1/fileupload`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Add Complaint --------------------
  function addComplaint(data) {
    const requestOptions = {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify(data),
    };
    const url = `${basePath}/v1/addProcedure`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Add Reference --------------------
  function addReference(data) {
    const requestOptions = {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify(data),
    };
    const url = `${basePath}/v1/ipd/reference`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- List Patients --------------------
  function ListPatients(data) {
    const requestOptions = {
      method: "GET",
      headers: buildHeaders(),
    };
    const url = `${basePath}/v1/patients?targetId=${data.targetId}&floorId=${data.floorId}&department=${data.department}`;
  return apiFetch(url, requestOptions);
  }

  // -------------------- List Visits --------------------
  export async function ListVisits(data) {
    const requestOptions = {
      method: "GET",
      headers: buildHeaders(),
    };
    let reqParam = "";
    if (data && data.patientType) {
      reqParam += `?patientType=${data.patientType}`;
    }
    if (data && data.patientName) {
      reqParam += reqParam
        ? `&patientName=${data.patientName}`
        : `?patientName=${data.patientName}`;
    }
    const url = `${basePath}/v1/visits${reqParam}`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Get Insurance Status --------------------
  function getInsuranceStatus(visitIdList) {
    console.log("visit id in service:", visitIdList);
    const requestOptions = {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify(visitIdList),
    };
    const url = `${basePath}/v1/insurance/getStatus`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Get Action List --------------------
  function getActionList(visitIdList) {
    console.log("visit id in service:", visitIdList);
    const requestOptions = {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify(visitIdList),
    };
    const url = `${basePath}/v1/visitaction`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- List Revisits --------------------
  function ListRevisits(date1, date2, searchFollowUps) {
    const requestOptions = {
      method: "GET",
      headers: buildHeaders(),
    };
    const url = `${basePath}/v1/revisits?Date1=${date1}&Date2=${date2}&SearchedFolUp=${searchFollowUps}`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Add Revisit --------------------
  function addRevisit(data, resCb) {
    const requestOptions = {
      method: "PUT",
      headers: buildHeaders(),
      body: JSON.stringify(data),
    };
    const url = `${basePath}/v1/revisitupdate`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Re-Add Visit --------------------
  function reAddVisit(data) {
    const requestOptions = {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify(data),
    };
    const url = `${basePath}/v1/readdvisit`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Add Appointment --------------------
  function addAppointment(data, type, resCb) {
    const requestOptions = {
      method: "PUT",
      headers: buildHeaders(),
      body: JSON.stringify(data),
    };
    const url = `${basePath}/v1/appointment?type=${type}`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Leave Calendar --------------------
  function leaveCalender(data, gvid, date, resCb) {
    console.log("data", data);
    const requestOptions = {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify(data),
    };
    const url = `${basePath}/v1/leaveCalender?gvid=${gvid}&apptdate=${date}`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Update Leave Calendar --------------------
  function updateleaveCalender(gvid, date, resCb) {
    const requestOptions = {
      method: "PUT",
      headers: buildHeaders(),
    };
    const url = `${basePath}/v1/leaveCalender?gvid=${gvid}&apptdate=${date}`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Get Leave Calendar --------------------
  function getleaveCalender(gvid, date, resCb) {
    const requestOptions = {
      method: "GET",
      headers: buildHeaders(),
    };
    const url = `${basePath}/v1/leaveCalender?gvid=${gvid}&apptdate=${date}`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Get Patient Profile --------------------
  async function getPatientProfile(patientId, visitId) {
    const requestOptions = {
      method: "GET",
      headers: buildHeaders(),
    };
    let url = `${basePath}/v1/patientProfile?patientId=${patientId}`;
    
    // optional visitId
    if (visitId) {
      url += `&visitId=${visitId}`;
    }
    
    return apiFetch(url, requestOptions);
  }

  // -------------------- File Upload --------------------
  function fileUpload(fileUploadData, percentageProgressHandler) {
    console.log("fileupload api call ");
    var accessToken;
    if (helperServices.getAuthorization()) {
      accessToken = helperServices.getAuthorization();
    }
    let formData = new FormData();
    var patientId = fileUploadData["id"];
    var visitId = fileUploadData["visitId"];
    var typeOf = fileUploadData["typeOf"];
    console.log("patientId : ", patientId);
    for (let i = 0; i < fileUploadData["fileData"].length; i++) {
      console.log("CService for loop : ", fileUploadData["fileData"][i].name);
      formData.append(
        "file",
        fileUploadData["fileData"][i],
        fileUploadData["fileData"][i].name
      );
    }
    console.log("FormData - ", formData);
    const url = `${basePath}/v1/fileupload?patientId=${patientId}&visitId=${visitId}&typeOf=${typeOf}`;
    return new Promise(function (resolve, reject) {
      let progressHandler = function (event) {
        var percent = Math.round((event.loaded / event.total) * 100);
        console.log("#progressHandler percent", percent);
      };
      let completeHandler = function (event) {
        console.log("event.target.responseText;", event.target.responseText);
        if (event.target.status >= 200 && event.target.status < 300) {
          resolve(JSON.parse(event.target.response));
        } else {
          reject({
            status: event.target.status,
            statusText: event.target.statusText,
          });
        }
      };
      let errorHandler = function (event) {
        reject({
          status: event.target.status,
          statusText: event.target.statusText,
        });
      };
      var ajax = new XMLHttpRequest();
      ajax.upload.addEventListener("progress", progressHandler, false);
      ajax.addEventListener("load", completeHandler, false);
      ajax.addEventListener("error", errorHandler, false);
      ajax.addEventListener("abort", errorHandler, false);
      ajax.open("POST", url);
      ajax.setRequestHeader("Authorization", accessToken);
      ajax.send(formData);
    });
  }

  function getUploadFile(uploadId) {
    const requestOptions = {
      method: "GET",
      headers: buildHeaders(),
    };
    const url = `${basePath}/v1/upload/${uploadId}`;
    return apiFetch(url, requestOptions);
  }
  // -------------------- Get Patient Procedure Info --------------------
  function getPatientProcedureInfo(patientId, visitId, type) {
    const requestOptions = {
      method: "GET",
      headers: buildHeaders(),
    };
    console.log("patient services in procedures");
    const url = `${basePath}/v1/procedure?patientId=${patientId}&visitId=${visitId}&type=${type}`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Patient Search --------------------
  function patientSearch(postObj) {
    console.log("data", postObj);
    let dateFrom = postObj.dateFrom ? postObj.dateFrom : "";
    let dateTo = postObj.dateTo ? postObj.dateTo : "";
    const page = postObj.page != null ? postObj.page : 0;
    const pagesize = postObj.pageSize != null ? postObj.pageSize : 16;
    const activeOnly = postObj.activeOnly != null ? postObj.activeOnly : (postObj.bodyParams && postObj.bodyParams.activeOnly != null ? postObj.bodyParams.activeOnly : "");
    const activeOnlyParam = activeOnly !== "" ? `&activeOnly=${activeOnly}` : "";
    const requestOptions = {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify(postObj.bodyParams),
    };
    console.log("patient services in patientsearch", postObj);
    const url = `${basePath}/v1/search?dateFrom=${dateFrom}&dateTo=${dateTo}&page=${page}&size=${pagesize}${activeOnlyParam}`;
    return apiFetch(url, requestOptions);
  }

// -------------------- Follow Up By Doctor --------------------
function followUpByDoctor(data) {
  const requestOptions = {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };
  const url = `${basePath}/v1/followUpByDoctor`;
  return apiFetch(url, requestOptions, { showLoader: false }); // ← ADD { showLoader: false }
}

  // -------------------- Get Revisit By ID --------------------
  function getrevisitbyId(patientId, visitId) {
    const requestOptions = {
      method: "GET",
      headers: buildHeaders(),
    };
    console.log("patient services in procedures");
    const url = `${basePath}/v1/getrevisitbyId?patientId=${patientId}&visitId=${visitId}`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Update VA Status --------------------
  function updateVAStatus(data, resCb) {
    const requestOptions = {
      method: "PUT",
      headers: buildHeaders(),
      body: JSON.stringify(data),
    };
    const url = `${basePath}/v1/closeAssignment`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Save Discharge Summary --------------------
  function saveDischargeSummary(data, resCb) {
    console.log("data : ", data);
    const requestOptions = {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify(data),
    };
    const url = `${basePath}/v1/saveDischargeSummary`;
    return apiFetch(url, requestOptions, { showLoader: false });
  }

  // -------------------- Save Discharge Date --------------------
  function saveDischargeDate(data, resCb) {
    console.log("data : ", data);
    const requestOptions = {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify(data),
    };
    const url = `${basePath}/v1/saveDischargeDate`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Save Visit Assignment --------------------
function saveVisitAssignment(data, resCb) {
  const requestOptions = {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };
  const url = `${basePath}/v1/saveVisitAssignment`;
  return apiFetch(url, requestOptions, { showLoader: false }); 
}

  // -------------------- Update Discharge Summary --------------------
  function updateDischargeSummary(data, resCb) {
    console.log("data : ", data);
    const requestOptions = {
      method: "PUT",
      headers: buildHeaders(),
      body: JSON.stringify(data),
    };
    const url = `${basePath}/v1/procedureUpdate`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Mark For Delete --------------------
  function markForDel(data, resCb) {
    console.log("data : ", data);
    const requestOptions = {
      method: "PUT",
      headers: buildHeaders(),
      body: JSON.stringify(data),
    };
    const url = `${basePath}/v1/markForDel`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Mark For Delete Insurance --------------------
  function markForDelInsurance(data, resCb) {
    console.log("data : ", data);
    const requestOptions = {
      method: "PUT",
      headers: buildHeaders(),
      body: JSON.stringify(data),
    };
    const url = `${basePath}/v1/markForDelInsurance`;
    return apiFetch(url, requestOptions);
  }


  // -------------------- Get Discharge Summary --------------------
  function getDischargeSummary(data, details) {
    console.log("data : , details :  ", data, details);
    const requestOptions = {
      method: "GET",
      headers: buildHeaders(),
    };
    const url = `${basePath}/v1/procedure/group?patientId=${details.patientId}&visitId=${details.visitId}&groupname=${details.groupname}${details.subgroup ? `&subgroup=${details.subgroup}` : ''}`;
    return apiFetch(url, requestOptions );
  }

  // -------------------- Get Discharge Summary --------------------
  function getDischargeSummaryForAutoSave(data, details) {
    const requestOptions = {
      method: "GET",
      headers: buildHeaders(),
    };
    const url = `${basePath}/v1/procedure/group?patientId=${details.patientId}&visitId=${details.visitId}&groupname=${details.groupname}`;
    return apiFetch(url, requestOptions , { showLoader: false });
  }

  // -------------------- Get Visit By ID --------------------
  function getVisitbyId(data) {
    const requestOptions = {
      method: "GET",
      headers: buildHeaders(),
      body: JSON.stringify(data),
    };
    const url = `${basePath}/v1/visit/groupId`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Update Group ID --------------------
  function updateGroupId(data) {
    const requestOptions = {
      method: "PUT",
      headers: buildHeaders(),
      body: JSON.stringify(data),
    };
    const url = `${basePath}/v1/visit/groupId`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Get Patient Procedure By Visit Date --------------------
  function getPatientProcedureByVisitDate(data) {
    const requestOptions = {
      method: "GET",
      headers: buildHeaders(),
    };
    console.log("patient services in procedures");
    const url = `${basePath}/v1/procedure/visitDate?patientId=${data.patientId}&visitId=${data.visitId}`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Get Visit List By ID --------------------
  function getVisitListById(visitId, type) {
    const requestOptions = {
      method: "GET",
      headers: buildHeaders(),
    };
    const url = `${basePath}/v1/visit?visitId=${visitId}&type=${type}`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Get Doctor Calendar By Date --------------------
  function getDoctorCalenderByDate(data) {
    const requestOptions = {
      method: "GET",
      headers: buildHeaders(),
    };
    console.log("Doctor Calender By Date");
    const url = `${basePath}/v1/calenderForDoc?gvid=${data.gvid}&apptdate=${data.apptdate}`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Get Doctor Calendar For Patient --------------------
  function getDoctorCalenderForPatient(data) {
    const requestOptions = {
      method: "GET",
      headers: buildHeaders(),
    };
    console.log("Doctor Calender for Patient");
    const url = `${basePath}/v1/calenderForPatient?gvid=${data.gvid}&patientId=${data.patientId}`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Onboard Patient --------------------
  function onboardPatient(data, type, admissionDateTime) {
	const visitFlag = data?.visitflag || "";
    const requestOptions = {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify(data),
    };
	const url = `${basePath}/v1/onboard?type=${encodeURIComponent(type)}&admissionDate=${encodeURIComponent(admissionDateTime || "")}&visitFlag=${encodeURIComponent(visitFlag)}`;
    console.log("[onboard API] admissionDate sent to server (before encode):", admissionDateTime, "| type:", type);
    return apiFetch(url, requestOptions);
  }

  // -------------------- Cancel Doctor Calendar By Patient ID --------------------
  function cancelDoctorCalenderByPatientId(data) {
    const requestOptions = {
      method: "PUT",
      headers: buildHeaders(),
    };
    console.log("Cancel Doctor Calender By patientId");
    const url = `${basePath}/v1/cancelDoctorAppointment?gvid=${data.gvid}&apptdate=${data.date}&patientId=${data.patientId}&vaId=${data.vaid}&type=${data.type}`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- List Prescriptions --------------------
  function ListPrescriptions(data, patientEhrid) {
    const requestOptions = {
      method: "GET",
      headers: buildHeaders(),
    };
    console.log("Doctor Calender By Date");
    const url = `${basePath}/v1/ehr/ListComposition?compositionIdList=${data}&patientEhrid=${patientEhrid}`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Prescriptions --------------------
  function prescriptions(data) {
    const requestOptions = {
      method: "GET",
      headers: buildHeaders(),
    };
    console.log("Doctor Calender By Date");
    const url = `${basePath}/v1/prescriptions`;
    return fetch(url, requestOptions)
      .then(handleResponse)
      .then((data) => {
        console.log("prescriptions", data);
        return [
          { serialNo: 1, medicineName: "dolo", units: "650", dosage: "1+0+1" },
          {
            serialNo: 2,
            medicineName: "dolodf gdfdfdf",
            units: "650",
            dosage: "1+0+1",
          },
          { serialNo: 2, medicineName: "dolodf", units: "650", dosage: "1+0+1" },
        ];
      })
      .catch((error) => {
        console.log(error);
      });
  }

  // -------------------- Move To Billing --------------------
  function moveToBilling(data) {
    console.log("Data in move to bill", data);
    const requestOptions = {
      method: "GET",
      headers: buildHeaders(),
    };
    const url = `${basePath}/v1/moveSOtoBilling?patientId=${data.patientId}&visitId=${data.visitId}&dischargeDate=${data.dischargeDate}`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- ERP V2 Move To Bill --------------------
  function erpV2moveToBill(data) {
    console.log("Data in move to bill", data);
    const requestOptions = {
      method: "GET",
      headers: buildHeaders(),
    };
    const url = `${basePath}/v2/moveSOtoBilling?patientId=${data.patientId}&visitId=${data.visitId}&dischargeDate=${data.dischargeDate}&checkType=${data.checkType}`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- SO ID Check --------------------
  function soIdCheck(data) {
    const requestOptions = {
      method: "GET",
      headers: buildHeaders(),
    };
    const url = `${basePath}/v1/soIdCheck?patientId=${data.patientId}&visitId=${data.visitId}`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Bill Clear Status --------------------
  function billclearstatus(data) {
    const requestOptions = {
      method: "GET",
      headers: buildHeaders(),
    };
    const url = `${basePath}/v1/billclearstatus?patientId=${data.patientId}&visitId=${data.visitId}`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Room Deallocate --------------------
  function roomDealocate(data) {
    const requestOptions = {
      method: "POST",
      headers: buildHeaders(),
    };
    const url = `${basePath}/v1/roomDealocate?patientId=${data.patientId}&visitId=${data.visitId}&dischargeDate=${data.dischargeDate}&checkType=${data.checkType}`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Registration Fees --------------------
  function registrationFees(
    customerId,
    totalfees,
    visitId,
    patientId,
    type,
    data
  ) {
    const requestOptions = {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify(data),
    };
    const url = `${basePath}/v1/registrationFees?customerId=${customerId}&totalFees=${totalfees}&visitId=${visitId}&patientId=${patientId}&type=${type}`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Total Fees --------------------
  function totalFees(patientId, visitId) {
    const requestOptions = {
      method: "GET",
      headers: buildHeaders(),
    };
    const url = `${basePath}/v1/registration/amount?patientId=${patientId}&visitId=${visitId}`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Get Vouchers --------------------
  function getVouchers(erpCustId) {
    const requestOptions = {
      method: "POST",
      headers: buildHeaders(),
    };
    const url = `${basePath}/v1/getVoucher?erpCustId=${erpCustId}`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Get Redeemed Vouchers --------------------
  function getRedeemedVouchers(erpCustId) {
    const requestOptions = {
      method: "POST",
      headers: buildHeaders(),
    };
    const url = `${basePath}/v1/redeemedVoucher?erpCustId=${erpCustId}`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Redeem Voucher --------------------
  function redeemVoucher(visitId, pateintId, voucherInfo) {
    const requestOptions = {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify(voucherInfo),
    };
    const url = `${basePath}/v1/redeemVoucher?visitId=${visitId}&pateintId=${pateintId}`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Get Redeemed Voucher --------------------
  function getRedeemeedVoucher(pateintId) {
    const requestOptions = {
      method: "POST",
      headers: buildHeaders(),
    };
    const url = `${basePath}/v1/redeemedVoucher?pateintId=${pateintId}`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Add To Procedure --------------------
  function addToProcedure(data, resCb) {
    console.log("data : ", data);
    const requestOptions = {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify(data),
    };
    const url = `${basePath}/v1/procedure`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Get Appointed Patient Details --------------------
  function getAppointedPatientDetails(pateintIds) {
    const requestOptions = {
      method: "POST",
      headers: buildHeaders(),
    };
    const url = `${basePath}/v1/getAppointedPatientDetails?patientIds=${pateintIds}`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Get Registration PDF --------------------
  function getRegistrationPDF(pateintIds) {
    const requestOptions = {
      method: "POST",
      headers: buildHeaders(),
    };
    const url = `${basePath}/v1/getRegistrationPDF?patientIds=${pateintIds}`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Check Scanner --------------------
  function checkScanner() {
    var accessToken;
    if (helperServices.getAuthorization()) {
      accessToken = helperServices.getAuthorization();
    }
    const requestOptions = {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
    };
    const url = `http://127.0.0.1:5000/api/checkScanner`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Upload Token --------------------
  function uploadToken(data) {
    console.log("data in service method", data);
    const requestOptions = {
      method: "POST",
      headers: buildHeaders(),
    };
    const url = `${basePath}/v1/uploadToken?patientId=${data.patientId}&visitId=${data.visitId}`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Scan Document --------------------
  function scanDocument(authToken) {
    var accessToken;
    if (helperServices.getAuthorization()) {
      accessToken = helperServices.getAuthorization();
    }
    const requestOptions = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
    };
    const url = `http://127.0.0.1:5000/api/scanDocument?authToken=${authToken}&&accessToken=${accessToken}`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Delete Package Service --------------------
  function deletePackageService(packageServiceId) {
    const requestOptions = {
      method: "PUT",
      headers: buildHeaders(),
    };
    const url = `${basePath}/v1/deletePackageService?id=${packageServiceId}`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Update To In-Site Patient --------------------
  function UpdateToInSitePatient(visitId, visitDate) {
    const requestOptions = {
      method: "PUT",
      headers: buildHeaders(),
    };
    const url = `${basePath}/v1/updateInternalStatus?visitId=${visitId}&visitDate=${visitDate}`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Send Print --------------------
  function sendPrint(data, idCard, barcode, token) {
    var accessToken;
    if (helperServices.getAuthorization()) {
      accessToken = helperServices.getAuthorization();
    }
    const requestOptions = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
      body: JSON.stringify(data),
    };
    const url = `http://127.0.0.1:9090/api/v1/sendPrint/details?idCard=${idCard}&barcode=${barcode}&token=${token}`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Edit Procedure --------------------
  function editProcedure(data, resCb) {
    console.log("data : ", data);
    const requestOptions = {
      method: "PUT",
      headers: buildHeaders(),
      body: JSON.stringify(data),
    };
    const url = `${basePath}/v1/editProcedure`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Validate Patient Status --------------------
  function validatePatientStatus(patientId, visitId, erpCustId) {
    const requestOptions = {
      method: "GET",
      headers: buildHeaders(),
    };
    console.log("patient status");
    const url = `${basePath}/v1/validatePatientStatus?patientId=${patientId}&visitId=${visitId}&erpCustId=${erpCustId}`;
    return apiFetch(url, requestOptions);
  }

  function PatientVisitBillingStatus(visitId, flag) {
    const requestOptions = {
      method: "POST",
      headers: buildHeaders(),
    };
    const url = `${basePath}/v1/patientVisitBillingStatus?visitId=${visitId}&flag=${flag}`;
    return apiFetch(url, requestOptions);
  }

  function ValidateShortDesc(
    procedureId,
    patientId,
    visitId,
    notes,
    selectedTest
  ) {
    const requestOptions = {
      method: "POST",
      headers: buildHeaders(),
    };
    const url = `${basePath}/v1/validate_shortdesc?procedureId=${procedureId}&patientId=${patientId}&visitId=${visitId}&selectedTest=${selectedTest}&notes=${notes}`;
    return apiFetch(url, requestOptions);
  }

  // -------------------- Generate Session Id --------------------
  // Called on tab open - generates new session ID in backend and returns it
  function generateSessionId(patientId, visitId) {
    const requestOptions = {  
      method: "GET",
      headers: {
        ...buildHeaders(),
        "Cache-Control": "no-cache, no-store",
        "Pragma": "no-cache",
      },
    };
    const url = `${basePath}/v1/generateSessionId?patientId=${patientId}&visitId=${visitId}&_t=${Date.now()}`;
    return apiFetch(url, requestOptions);
}

export const getNewFormId = async (patientId, visitId, formType) => {

    const requestOptions = {
        method: "GET",
        headers: buildHeaders(),
    };
  const url = `/api/v1/form/formId?formType=${encodeURIComponent(formType)}&visitId=${visitId}&patientId=${patientId}`;

  return apiFetch(url, requestOptions);
  }
    
export const getFormTextContent = (formType) => {

    const requestOptions = {
        method: "GET",
        headers: buildHeaders(),
    };

    const url =
        "/api/v1/form-content?formType=" +
        encodeURIComponent(formType);

    return apiFetch(url, requestOptions);
};

  // -------------------- Validate Session Id --------------------
  // Called before save - backend does simple string comparison
function validateSessionId(patientId, visitId, sessionId) {
  const requestOptions = {
    method: "POST",
    headers: buildHeaders(),
  };
  const url = `${basePath}/v1/validateSessionId?patientId=${patientId}&visitId=${visitId}&sessionId=${encodeURIComponent(sessionId)}`;
  return apiFetch(url, requestOptions, { showLoader: false }); // ← ADD { showLoader: false }
}

function removeVisitAssignment(data) {
  const requestOptions = {
    method: "PUT",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };
  const url = `${basePath}/v1/remove/visitAssignment`;
  return apiFetch(url, requestOptions);
}
  // -------------------- Export --------------------
  const patientServices = {
    handleResponse,
    logout,
    getAllPatientInfo,
    addPatient,
    getDoctors,
    uploadPatientImage,
    addDependent,
    dependentCheck,
    KeepDependents,
    updatePatient,
    addVisit,
    addProcedure,
    getVisitInfo,
    uploadAttachments,
    addComplaint,
    addReference,
    ListPatients,
    getPatientProfile,
    fileUpload,
    ListVisits,
    ListRevisits,
    addRevisit,
    reAddVisit,
    addAppointment,
    leaveCalender,
    updateleaveCalender,
    getleaveCalender,
    getPatientProcedureInfo,
    patientSearch,
    updateVAStatus,
    saveDischargeSummary,
    updateDischargeSummary,
    getDischargeSummary,
    getVisitbyId,
    updateGroupId,
    markForDel,
    markForDelInsurance,
    getPatientProcedureByVisitDate,
    getInsuranceList,
    addInsuranceProcedure,
    updateInsuranceProcedure,
    getVisitListById,
    getDoctorCalenderByDate,
    onboardPatient,
    cancelDoctorCalenderByPatientId,
    EditInsuranceSettlements,
    ListInsuranceSettlements,
    prescriptions,
    ListPrescriptions,
    moveToBilling,
    roomDealocate,
    getInsuranceStatus,
    getActionList,
    demoCon,
    registrationFees,
    totalFees,
    getVouchers,
    getrevisitbyId,
    redeemVoucher,
    getAppointedPatientDetails,
    getRedeemeedVoucher,
    getRegistrationPDF,
    getRedeemedVouchers,
    checkScanner,
    uploadToken,
    followUpByDoctor,
    scanDocument,
    deletePackageService,
    soIdCheck,
    billclearstatus,
    saveVisitAssignment,
    getDoctorCalenderForPatient,
    saveDischargeDate,
    UpdateToInSitePatient,
    sendPrint,
    getCustomerGroupInfo,
    editProcedure,
    addToProcedure,
    validatePatientStatus,
    erpV2moveToBill,
    updatePatientAdhaar,
    PatientVisitBillingStatus,
    ValidateShortDesc,
    generateSessionId,   
    validateSessionId,  
    removeVisitAssignment,
    getDischargeSummaryForAutoSave, 
    getUploadFile,
    getFormTextContent,
    getNewFormId,
  };

  export default patientServices; 
